<template>
  <div style="margin-top:30px">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="80px"
    >
      <el-form-item
        label="标题"
        prop="title"
        style="margin-right:15px"
      >
        <el-input
          v-model.trim="form.title"
          placeholder="请输入标题"
          @change="(value)=>{form.title = value.replace(/\s/g,'')}"
        />
      </el-form-item>
      <el-form-item
        label="内容"
        prop="content"
        style="margin-right:15px"
      >
        <el-input 
          v-model="form.content" 
          placeholder="请输入内容" 
          type="textarea"
        />
      </el-form-item>
      <el-form-item
        label="类型"
        prop="type"
        style="margin-right:15px"
      >
        <el-select
          v-model="form.type"
          placeholder="请选择类型"
          style="width: 100%"
          clearable
        >
          <el-option
            v-for="item in typeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button
        type="primary"
        @click="funcSubmit"
      >
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";

export default {
  name: "UnitAdd",
  data() {
    return {
      form: {
        code: '',
        title: '',
        content: '',
        isRelease: 1,
        type: ''
      },
      rules: {
        title: [
          { required: true, message: "请输入标题", trigger: "blur" },
          { min: 1, max: 100, message: "长度在 1 到 100 个字符", trigger: "blur" }
        ],
        content: [
            { required: true, message: "请输入内容", trigger: "blur" },
            { min: 1, max: 1000, message: "长度在 1 到 1000 个字符", trigger: "blur" }
        ],
        type: [
          { required: true, message: '请选择类型', trigger: 'blur' }
        ]
      },
      // 所属类型
      typeList: [
        {
          label: "常见问题",
          value: 4
        },
        {
          label: "法律咨询",
          value: 5
        }
      ]
    };
  },
  created() {

  },
  methods: {
    // 提交
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const rLoading = this.openLoading();
          const data = this.form;
          request({
            url: "/ntocc-basic-api/problem",
            method: "post",
            params: data
          })
            .then(response => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
              this.$emit("fatherAddMethod");
            })
            .then(() => this.$refs["form"].resetFields());
        } else {
          return false;
        }
      });
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "add");
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
